import { LitElement, html, customElement, property, css, unsafeCSS } from 'lit-element';
import QRCode from 'qrcode';

class OcArQr extends LitElement {

    static get properties() {
        return {
            active: { type: Boolean},
            code: { type: String },
            header: { type: String },
            text: { type: String },
            buttonText: { type: String }
        };
    }

    constructor() {
        super();
        this.active = false;
        this.code = "";
        this.header = I18N.hasKey("ArQrHeader") ? I18N("ArQrHeader") : undefined
        this.text = I18N("ArQrText")
        this.buttonText = I18N.hasKey("ArQrButtonText") ? I18N("ArQrButtonText") : "OK"
    }

    render() {
        return this.active ? html`
            ${this.style()}
            <div class="wrapper">
                ${this.header ? html`<h1 id="header">${this.header}</h1>` : html ``}
                <p id="text">${this.text}</p>
                <canvas id="QR"></canvas>
                <button id="btn-ok" @click=${() => this.close()}>${this.buttonText}</button>
            </div>
        ` : html``;
    }

    updated() {
        if (this.active) {
            const canvas = document.getElementById("QR");
            QRCode.toCanvas(canvas, location.href+"#openAR=true", (error) => {
                if (error) console.error(error);
                console.log("success QR Code generation");
            })
        }
        // To be sure its infront!
        document.getElementsByTagName("body")[0].append(this);

    }

    close() {
        this.active = false;
        this.requestUpdate();
    }

    createRenderRoot() {return this; }

    style() {
        return html`
            <style>
                oc-ar-qr {
                    font-size: 16px;
                    position: fixed;
                    left: 0px;
                    top: 0px;
                    height: 100vh;
                    width: 100vw;
                    z-index: 2147483647;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background-color: rgba(0,0,0,0.4);
                }
                oc-ar-qr .wrapper {
                    background-color: rgba(255, 255, 255, 0.97);
                    border: 1px solid #888;
                    padding: 20px;
                    width: 30vw;
                    height: 40vh;
                    margin-top: 20vh;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    text-align: center;
                }
                oc-ar-qr button {
                    background-color: #4CAF50; /* Green */
                    border: none;
                    color: white;
                    padding: 8px 16px;
                    text-align: center;
                    text-decoration: none;
                    display: inline-block;
                    margin: 4px 2px;
                    -webkit-transition-duration: 0.4s; /* Safari */
                    transition-duration: 0.4s;
                    cursor: pointer;
                    -webkit-transition-duration: 0.4s; /* Safari */
                    transition-duration: 0.4s;
                    background-color: white;
                    color: black;
                    border: 2px solid #e7e7e7;
                }
                oc-ar-qr button:hover {
                    background-color: #e7e7e7;
                }
            </style>
        `
    }
}
customElements.define('oc-ar-qr', OcArQr);
